var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.98,
    height: 19.98,
    viewBox: "0 0 19.98 19.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_72a250c0dfca7e825774af32f00fb7c0",
    "data-name": "72a250c0dfca7e825774af32f00fb7c0",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20611",
    "data-name": "Path 20611",
    d: "M21.314,6.329H18.65V5.663a3.663,3.663,0,0,0-7.326,0v.666H8.66A.666.666,0,0,0,7.994,7v4.329H3.332a.666.666,0,0,0-.664.618L2,21.267a.666.666,0,0,0,.664.714h16.65a2.667,2.667,0,0,0,2.664-2.664V7A.666.666,0,0,0,21.314,6.329Zm-8.658-.666a2.331,2.331,0,0,1,4.662,0v.666H12.656Zm-8.7,6.993H11.37l.571,7.992H3.381Zm16.7,6.66a1.333,1.333,0,0,1-1.332,1.332h-6.04l-.622-8.706a.666.666,0,0,0-.664-.618H9.326V7.661H20.648Z",
    transform: "translate(0 0)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20612",
    "data-name": "Path 20612",
    d: "M16,38a.666.666,0,0,0-.666.666V39a1,1,0,0,1-2,0v-.333a.666.666,0,0,0-1.332,0V39a2.331,2.331,0,1,0,4.662,0v-.333A.666.666,0,0,0,16,38Z",
    transform: "translate(-6.67 -24.012)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrders);
export default __webpack_public_path__ + "static/media/Purchase Orders.00e4e537f6a94624b8f38d818143b882.svg";
export { ForwardRef as ReactComponent };